import { FaUserPlus, FaSyncAlt, FaMoneyBillWave, FaTimesCircle } from "react-icons/fa";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import Select from "react-select";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { MdOutlinePersonOff } from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi";
function DailyAttendence() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [attendanceData, setAttendanceData] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editedStatus, setEditedStatus] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [getStaff, setGetStaff] = useState([]);
  const [editedOverTime, setEditedOverTime] = useState("");
  const [presentCount, setPresentCount] = useState(0);
  const [absentCount, setAbsentCount] = useState(0);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const statusOptions = [{
    value: "Present",
    label: "Present"
  }, {
    value: "Absent",
    label: "Absent"
  }, {
    value: "Leave",
    label: "Leave"
  }];
  const totalStaff = getStaff.length;
  const handleSave = async id => {
    try {
      await axios.put("https://api.sweepydo.in/update-attendance", {
        id,
        status: editedStatus,
        over_time: editedOverTime
      });
      showToast("Status Updated Successfully!", "success");
      fetchAttendence();
      setEditRowId(null);
    } catch (error) {
      console.log(error);
      showToast("Failed to update status!", "danger");
    }
  };
  const fetchAttendence = async () => {
    try {
      let url = "https://api.sweepydo.in/fetch-attendence";
      if (fromDate && toDate) {
        url += `?from=${fromDate}&to=${toDate}`;
      }
      const res = await axios.get(url);
      const data = res.data;
      setAttendanceData(data);
      // console.log(res.data);

      const present = data.filter(item => item.status === "Present").length;
      const absent = totalStaff - present;
      setPresentCount(present);
      setAbsentCount(absent);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSetaff = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-staff");
      setGetStaff(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchSetaff();
  }, []);
  useEffect(() => {
    if (getStaff.length > 0) {
      fetchAttendence();
    }
  }, [getStaff]);
  const filteredData = Array.isArray(attendanceData) ? attendanceData.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  return <div className="container-fluid mt-1 p-4">

  <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
    <h2 className="text-center mb-4 text-white">Daily Attendence </h2>

   <div className="row mb-4">


  <div className="col-md-4 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Total Staff</h6>
        <h4>{totalStaff} </h4>
      
      </div>
      <div className="bg-warning text-white p-2 rounded-circle">
        <HiOutlineUserGroup size={25} />
      </div>
    </div>
  </div>

  <div className="col-md-4 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Present Staff</h6>
       <h4>{presentCount}</h4>
    
      </div>
      <div className="bg-primary text-white p-2 rounded-circle">
        <FaUserPlus size={25} />
      </div>
    </div>
  </div>

  <div className="col-md-4 mb-3">
    <div className="card p-4 shadow-lg  border border-secondary rounded-4 d-flex flex-row justify-content-between align-items-center text-white" style={{
          backgroundColor: "var(--black)",
          minHeight: "140px"
        }}>
      <div>
        <h6>Absent</h6>
       <h4>{absentCount}</h4>
      </div>
      <div className="bg-success text-white p-2 rounded-circle">
        <MdOutlinePersonOff size={24} />
      </div>
    </div>
  </div>



</div>


<div className="shadow rounded my-4" style={{
      backgroundColor: "var(--black)",
      padding: "20px"
    }}>

  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">


    <div style={{
          width: "280px"
        }}>
      <input type="text" className="form-control" placeholder="Search ..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            backgroundColor: "var(--black2)",
            color: "#fff",
            border: "1px solid #2d3748",
            borderRadius: "10px",
            padding: "10px 14px"
          }} />
    </div>

   <div className="d-flex gap-2 mt-2 mt-md-0 align-items-end flex-wrap">

  {/* From Date */}
  <div style={{
            minWidth: "180px"
          }}>
    <label className="form-label text-white">From Date</label>
    <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
              backgroundColor: "var(--black2)",
              color: "#fff",
              border: "1px solid #444"
            }} />
  </div>

  {/* To Date */}
  <div style={{
            minWidth: "180px"
          }}>
    <label className="form-label text-white">To Date</label>
    <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
              backgroundColor: "var(--black2)",
              color: "#fff",
              border: "1px solid #444"
            }} />
  </div>

  {/* Button */}
  <div>
    <button className="btn btn-primary" style={{
              height: "38px"
            }} onClick={fetchAttendence}>
      Apply
    </button>
  </div>

</div>
  </div>

  <div className="table-responsive">
    <table className="table align-middle text-center" style={{
          marginBottom: 0
        }}>
      <thead>
        <tr>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>SN</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Name</th>
            <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Check In </th>
                   <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Check Out </th>
              <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Status</th>
                  <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Over Time</th>
          <th style={{
                backgroundColor: "var(--black2)",
                color: "#fff"
              }}>Action</th>
        </tr>
      </thead>

 


<tbody>
  {filteredData.length > 0 ? filteredData.map((item, index) => <tr key={item.id}>

        <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {index + 1}
        </td>
        <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {item.staff_name || "N/A"}
        </td>

        <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {item.check_in ? item.check_in.split(" ")[0] : "-"}
        </td>
         <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {item.check_out ? item.check_out.split(" ")[0] : "-"}
        </td>
        <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {editRowId === item.id ? <Select options={statusOptions} value={statusOptions.find(opt => opt.value === editedStatus)} onChange={selected => setEditedStatus(selected.value)} className="w-75" classNamePrefix="custom-select" menuPortalTarget={document.body} menuPosition="fixed" /> : <span>{item.status}</span>}
        </td>


  <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {editRowId === item.id ? <input type="time" className="form-control form-control-sm" value={editedOverTime || ""} onChange={e => setEditedOverTime(e.target.value)} /> : <span>{item.over_time}</span>}
        </td>
      
        <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }}>
          {editRowId === item.id ? <>
              <button className="btn btn-success btn-sm me-1" onClick={() => handleSave(item.id)}>
                Save
              </button>

              <button className="btn btn-secondary btn-sm" onClick={() => setEditRowId(null)}>
                Cancel
              </button>
            </> : <button className="btn btn-primary btn-sm" onClick={() => {
                  setEditRowId(item.id);
                  setEditedStatus(item.status);
                  setEditedOverTime(item.over_time || "");
                }}>
              Edit
            </button>}
        </td>

      </tr>) : <tr>
      <td style={{
                backgroundColor: "var(--black)",
                color: "#fff"
              }} colSpan="7">
        No data found
      </td>
    </tr>}
</tbody>
    </table>
  </div>

</div>


    </div>;
}
export default DailyAttendence;
